"use strict";

exports.__esModule = true;
exports.gridItemPropTypes = exports.gridPropTypes = void 0;

var _propTypes = require("prop-types");

var _constants = require("./constants");

var stringOrArrayOfStringsPropType = function stringOrArrayOfStringsPropType(constant) {
  var strings = Object.keys(constant);
  return (0, _propTypes.oneOfType)([(0, _propTypes.oneOf)(strings), (0, _propTypes.arrayOf)((0, _propTypes.oneOf)(strings))]);
};

var gridPropTypes = {
  alignItems: stringOrArrayOfStringsPropType(_constants.ALIGN_ITEMS),
  breakpoints: (0, _propTypes.arrayOf)((0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string])),
  children: _propTypes.node,
  columns: _propTypes.number,
  gutterWidth: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string])
};
exports.gridPropTypes = gridPropTypes;
var gridItemPropTypes = {
  span: (0, _propTypes.oneOfType)([_propTypes.number, (0, _propTypes.arrayOf)(_propTypes.number)])
};
exports.gridItemPropTypes = gridItemPropTypes;